import { baseApi } from 'core/api/base'
import { IPromptHistory } from 'core/interfaces/PromptHistory'
import { generatePath } from 'react-router'

const PROMPT_HISTORISES_BASE_ENDPOINT = '/prompts-historises'
const PROMPT_HISTORISE_ENDPOINT = `${PROMPT_HISTORISES_BASE_ENDPOINT}/:promptHistoriseId`

const promptHistoriseApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getAllPromptHistorises: builder.query<
      IPromptHistory[],
      { promptId: number }
    >({
      query: ({ promptId }) =>
        `${PROMPT_HISTORISES_BASE_ENDPOINT}?prompt.id=${promptId}`,
    }),
    getPromptHistorise: builder.query<
      IPromptHistory,
      { promptHistoriseId: number }
    >({
      query: ({ promptHistoriseId }) =>
        generatePath(PROMPT_HISTORISE_ENDPOINT, {
          promptHistoriseId: promptHistoriseId.toString(),
        }),
    }),
  }),
})

export const { useGetAllPromptHistorisesQuery, useGetPromptHistoriseQuery } =
  promptHistoriseApi
export { promptHistoriseApi }
